// extracted by mini-css-extract-plugin
export default {"up":"widget-athlete-list-medium-row_up__039s9","down":"widget-athlete-list-medium-row_down__Rc8ZB"};